export var LEFT_ITEMS = [{
  url: 'https://gaoding.com',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115221-dd97.svg',
  title: '稿定官网',
  desc: '海量海报模板，让设计更简单'
}, {
  url: 'https://koutu.gaoding.com/',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115420-5603.svg',
  title: '稿定抠图',
  desc: '在线删除图片背景'
}];
export var RIGHT_ITEMS = [{
  url: 'https://sucai.gaoding.com/',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115353-b68a.svg',
  title: '稿定素材'
}, {
  url: 'https://www.gaoding.com/image',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115550-7af6.svg',
  title: '图片编辑器'
}, {
  url: 'https://ps.gaoding.com/#/',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115639-771c.svg',
  title: '在线PS'
}, {
  url: 'https://www.gaoding.com/pintu',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115336-fccb.svg',
  title: '在线拼图'
}, {
  url: 'https://www.gaoding.com/poster-generator',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115605-72f8.svg',
  title: '一键生成海报'
}, {
  url: 'https://www.gaoding.com/ppt/plugin',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115623-969a.svg',
  title: 'PPT插件'
}, {
  url: 'https://www.gaoding.com/clipper',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115655-867a.svg',
  title: '在线剪视频'
}, {
  url: 'https://www.gaoding.com/odyssey/design',
  img: 'https://st-gdx.dancf.com/gaodingx/213/configs/system/20200907-115315-e243.svg',
  title: '手机网页制作'
}];